import { logOutServerSideAction } from './log-out-server-side-action';

const LEARN_INTERESTS_DISMISSED_KEY = 'learn-interests-dismissed';

export const logOut = async () => {
  sessionStorage.removeItem(LEARN_INTERESTS_DISMISSED_KEY);
  await logOutServerSideAction();
};
